import type { Square } from '../../game/types.js';
import { PIECE_RADIUS } from '../../utils/constants.js';
import { squareToCanvasCenter, type ViewerRotation } from '../geometry.js';
import type { RenderPalette } from '../palette.js';

/**
 * Canvas-drawn keyboard focus ring. Drawn only when the canvas owns
 * keyboard focus (caller's responsibility). Uses the palette's banner-border
 * accent so the visual language stays consistent with the AFK pulse hint
 * (and matches backgammon's iter 3 ring).
 *
 * `square` is in board coords; rotation handling lives in the geometry
 * helper, so a 180-rotated board flips visually without any logic here.
 */
export function drawKeyboardFocusRing(
  ctx: CanvasRenderingContext2D,
  square: Square,
  palette: RenderPalette,
  rotation: ViewerRotation = 0,
): void {
  const { x, y } = squareToCanvasCenter(square, rotation);
  ctx.save();
  ctx.beginPath();
  ctx.arc(x, y, PIECE_RADIUS + 6, 0, Math.PI * 2);
  ctx.strokeStyle = palette.bannerBorder;
  ctx.lineWidth = 3;
  ctx.setLineDash([5, 4]);
  ctx.stroke();
  ctx.restore();
}
